import { Pipe, PipeTransform } from '@angular/core';
import { NotebookVizResult } from '@mode/notebooks/domain';

/**
 * If the ContentType of the cell is text/html and the result type
 * is not an image, error or stderr
 */
@Pipe({
  name: 'notebookCellIsHtml',
  pure: true,
})
export class NotebookCellIsHtmlPipe implements PipeTransform {
  transform(cell: NotebookVizResult): boolean {
    return !['image', 'error', 'stderr'].some((t) => t === cell.result_type) && cell.content_type === 'text/html';
  }
}
